export default __webpack_public_path__ + "static/our-story-image-22d29f3d4b3a21dd796b8a97ccd855bc.png";